module.exports = __webpack_public_path__ + "media/images/icon_popup_licence_sp-f56eff47d68661941df95df73573d163.png";